export const markPerformanceStart = (startMarker = '') => {
  if (window && window.performance && startMarker) {
    const performance = window.performance;

    if (performance.mark === undefined) {
      console.log('performance.mark Not supported');
      return;
    }
    performance.mark(startMarker);
  }
};

export const markPerformanceEnd = (
  startMarker = '',
  endMarker = '',
  durationMarker = '',
): number => {
  let loadTime = 0;
  if (window && window.performance && startMarker && endMarker && durationMarker) {
    const performance = window.performance;
    const startcheck = performance.getEntriesByName(startMarker);
    if (startcheck.length) {
      performance.mark(endMarker);
      performance.measure(durationMarker, startMarker, endMarker);
      const durations = performance.getEntriesByName(durationMarker);
      if (durations.length) loadTime = durations[0].duration;
    }
  }
  performance.clearMarks();
  performance.clearMeasures();
  return loadTime;
};
